import React from 'react'
import { useNavigate } from 'react-router-dom'
import './global.scss'
import { toast } from 'react-toastify'
import GlobalFooter from './GlobalFooter'
function CanadaSuccess() {
    const record = JSON.parse(localStorage.getItem("auth"))

  // const redirect  = localStorage.getItem('flings')
  const redirect  = localStorage.getItem('redirect')
  const handleClick =()=>{
    if(redirect){
        window.location.href = redirect;
    }else{
        toast("No redirect url provided")
    }
} 
  return (
    <div className='global_layout'>
        {/* {
                 record?.avatar ?
                 <div className='img_container'>
                     <img className='img_glob' src={record?.avatar} alt=''/>
                 </div>:
                <div className='glob_avater custom_avater'>
                    <p className='glob_avater_text'>{String(record?.data?.business_name).slice(0, 1)}</p>
                </div>
        } */}
        <div className='global_container'>
            <div className='top_bar'>
                {/* <img src='/images/global/arrow-left.svg' alt=''/> */}
                <img src='/images/global/close.svg' alt='' style={{marginLeft:"auto"}} onClick={handleClick}/>
            </div>

            <div className='global_content'>
                <img style={{width:"60px",height:"60px"}} src='/images/global/success.gif' alt='' />
                <p className='glob_title'>Successful!</p>
                <p className='glob_desc'>Payment request successfully completed.</p>
                {/* <button className='btn' style={{marginTop:"18px",background:"#228985",borderRadius:"10000px"}} onClick={handleClick}>Ok, got it</button> */}
            </div>
        </div>
        {
            !record?.total_whitelabelling &&
            <GlobalFooter />
        }
    </div>
  )
}

export default CanadaSuccess